module.exports = __webpack_public_path__ + "img/banner_bottom.db838356.png";